import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=d9e05b68&scoped=true"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"
import style0 from "./advantages.vue?vue&type=style&index=0&id=d9e05b68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e05b68",
  null
  
)

export default component.exports